<script>
    import ChartsReportMixin from './ChartsReportMixin.vue';

    export default {
        name: 'ImpressionsReport',
        mixins: [ChartsReportMixin],
        data() {
            return {
                requests: {
                    impressions: this.$req('space/CategoryImpressionsReport'),
                    clicks: this.$req('space/CategoryClicksReport'),
                },
                currentChart: 'impressions',
            };
        },
        computed: {
            header() {
                return this.$t('traffic');
            },
            tooltip() {
                return this.$t('thePresentedDataIsNarrowedToStoresDisplayedInTheWidget');
            },
        },
        methods: {
            resetFilters() {
                ChartsReportMixin.methods.resetFilters.bind(this)();
                this.currentChart = 'impressions';
            },
        },
        created() {
            this.parentComponent.$on('resetFilters', this.resetFilters);
        },
        beforeDestroy() {
            this.parentComponent.$off('resetFilters', this.resetFilters);
        },
    };
</script>
